import { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export const MultiPick = ({ values, onChange, items, testId, allLabel = "All" }) => {
  const [search, setSearch] = useState("");
  const shown = items.filter((o) => o.toLowerCase().includes(search.toLowerCase()));
  const toggle = (o) => onChange(values.includes(o) ? values.filter((v) => v !== o) : [...values, o]);
  const label = values.length === 0 ? allLabel : values.length === 1 ? values[0] : `${values.length} selected`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid={testId}
          className="flex h-9 w-full items-center justify-between gap-2 rounded-md border border-input bg-white px-3 text-sm shadow-sm"
        >
          <span className={`truncate ${values.length ? "text-slate-900" : "text-slate-600"}`}>{label}</span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 bg-white p-2">
        <Input
          data-testid={`${testId}-search`}
          placeholder="Search…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mb-2 h-8"
        />
        <div className="max-h-64 overflow-y-auto">
          {shown.length === 0 && <div className="px-2 py-3 text-sm text-slate-500">No options</div>}
          {shown.map((o) => (
            <label key={o} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-slate-50">
              <Checkbox data-testid={`${testId}-option-${o}`} checked={values.includes(o)} onCheckedChange={() => toggle(o)} />
              <span className="truncate">{o}</span>
            </label>
          ))}
        </div>
        {values.length > 0 && (
          <button
            data-testid={`${testId}-clear`}
            onClick={() => onChange([])}
            className="mt-2 flex w-full items-center justify-center gap-1 rounded py-1.5 text-xs text-slate-600 hover:bg-slate-50"
          >
            <X className="h-3 w-3" /> Clear selection
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};
